// SortingMixin.js
export default {
  data () {
    return {
      sortColumn: '', // 초기 정렬 열
      sortDirection: 'asc' // 초기 정렬 방향
    }
  },
  methods: {
    toggleSort (column) {
      if (column === this.sortColumn) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortColumn = column
        this.sortDirection = 'asc'
      }
    }
  }
}
